import {schemaMatches} from "@jsonforms/core";
import {withJsonFormsControlProps} from "@jsonforms/react";
import moment from "moment";
import CustomDatePicker from "../../custom-date-picker";
import {RENDERER_TYPES} from "../constants";

export const DatePickerTester = schemaMatches(schema => schema.renderer === RENDERER_TYPES.datePicker);

export const DatePickerRenderer = withJsonFormsControlProps(
  ({label, data, handleChange, path, required, errors, schema}) => {
    return (
      <CustomDatePicker
        clearable
        fullWidth
        label={label}
        value={data}
        required={required}
        error={!!errors}
        helperText={errors}
        format={schema?.options?.dateFormat}
        onChange={value => {
          const date = value ? moment(value).toISOStringNoOffset() + "+00:00" : undefined;
          handleChange(path, date);
        }}
        className="custom-json-forms__renderers__date-picker"
      />
    );
  }
);
